<template>
    <div v-if="loading" class="loading">Loading...</div>
    <div :class="blur ? 'blur-lg' : '' " class="fixed h-screen w-screen bg-[url('../assets/background/city.jpg')] bg-cover bg-center bg-no-repeat">
        <div class="flex h-full p-2">

            <div class="h-screen w-1/6">
                <div class="flex flex-col relative p-5 gap-10">
                    <router-link :to="`/checkpoint`">
                        <div class="bg-white rounded-lg shadow-lg shadow-slate-500 w-fit p-2">
                            <img class="w-10" src="../assets/icon/icon-home.png" alt="home">
                        </div>
                    </router-link>
                    <div class="xl:mt-48 lg:mt-48 md:mt-10 sm:mt-10">
                        <img class="w-[600px] absolute" src="../assets/avatar/avatar-flip.png" alt="avatar">
                    </div>
                </div>
            </div>

            <div class="p-4 flex flex-col h-full w-4/6 justify-center items-center gap-y-2">           
                <div class="p-4 w-full flex justify-center items-center bg-transparent shadow-xl rounded-lg">
                    <p class="xl:text-6xl lg:text-6xl md:text-4xl sm:text-4xl">พบปะสิ่งใหม่</p>
                    <Sound :checkpoint='4' :autoplay='false' />
                </div> 
                
                <!-- Screen Content -->
                <div class="relative flex justify-center items-center p-4 border-4 rounded-lg shadow-lg w-full">          
                    <div>      
                        <img class="xl:w-full lg:w-full md:w-80 sm:w-72" :src="levels[$store.state.level].data[current_round].url" alt="monastery">
                    </div>
                </div> 

                <!-- Choice -->
                <div class="w-full mt-2 rounded-md drop-shadow-lg border-4 bg-transparent shadow-lg shadow-yellow-200">
                    <div class="flex justify-around border p-4">                    
                        <div @click="checkAnswer($store.state.level, choices.choice_one, levels[$store.state.level].data[current_round].answer)" class="transition ease-in-out delay-150 flex py-2 w-full mr-10 mb-2 justify-center border border-gray-700 rounded-lg shadow-lg shadow-orange-500 bg-indigo-500 hover:ring-4 hover:ring-indigo-400 hover:-translate-y-1 hover:scale-110 duration-300 cursor-pointer">
                            <p class="xl:text-4xl lg:text-2xl md:text-2xl sm:text-xl font-semibold text-white">{{ choices.choice_one }}</p>
                        </div>
                        <div @click="checkAnswer($store.state.level, choices.choice_two, levels[$store.state.level].data[current_round].answer)" class="transition ease-in-out delay-150 flex py-2 w-full mr-10 mb-2 justify-center border border-gray-700 rounded-lg shadow-lg shadow-orange-500 bg-indigo-500 hover:ring-4 hover:ring-indigo-400 hover:-translate-y-1 hover:scale-110 duration-300 cursor-pointer">
                            <p class="xl:text-4xl lg:text-2xl md:text-2xl sm:text-xl font-semibold text-white">{{ choices.choice_two }}</p>
                        </div>                        
                        <div @click="checkAnswer($store.state.level, choices.choice_tree, levels[$store.state.level].data[current_round].answer)" class="transition ease-in-out delay-150 flex py-2 w-full mr-10 mb-2 justify-center border border-gray-700 rounded-lg shadow-lg shadow-orange-500 bg-indigo-500 hover:ring-4 hover:ring-indigo-400 hover:-translate-y-1 hover:scale-110 duration-300 cursor-pointer">
                            <p class="xl:text-4xl lg:text-2xl md:text-2xl sm:text-xl font-semibold text-white">{{ choices.choice_tree }}</p>
                        </div>                        
                    </div>
                </div>
            </div>

            <div class="h-full flex flex-col w-1/6 justify-start items-center">
                <p class="my-4 p-8 xl:text-6xl lg:text-6xl md:text-4xl sm:text-4xl font-bold rounded-full bg-orange-300 border-4 text-white">{{ current_round + 1 }}/{{ levels[$store.state.level].round }}</p>
            </div>
        </div>
        <Answer :checkCorrect="checkCorrect" :star="star" :resetGame="resetGame" :nextCheckPoint="nextCheckPoint" />         
    </div>
    <HowTo :setShowContent="setShowContent" :checkpoint='4'/>
</template>

<script>
import HowTo from "../components/HowTo.vue";
import Sound from "../components/Sound.vue";
import Answer from "../components/Answer.vue";
import actionUpdateCheckpoint from '../js/firebase-action';
import logPlay from '../js/logs-play';
import soundAnswer from "../js/sound-answer";

const path = '../assets/checkpoint/4';

export default {
    name: "CheckPointScreen",
    components: {
        HowTo,
        Sound,
        Answer
    },    
    data(){
        return {
            blur: true,    
            checkCorrect: '',            
            star: 0,      
            countGameOver: 0,
            choices: {
                choice_one: 'วัด',
                choice_two: 'เเมว',
                choice_tree: 'รถยนต์',
            },
            current_round: 0,
            levels: {
                easy: {                                        
                    round: 1,
                    data: [
                        {
                            url: `${path}/see_the_monastery.gif`,                            
                            answer: 'วัด',                            
                        }                  
                    ]
                },
                medium: {   
                    round: 2,                                     
                    data: [                   
                        {
                            url: `${path}/see_the_monastery.gif`,                            
                            answer: 'วัด',                            
                        },
                        {
                            url: `${path}/see_the_cat.gif`,                            
                            answer: 'เเมว',                            
                        }
                    ]
                },
                hard: {   
                    round: 3,                                     
                    data: [                   
                        {
                            url: `${path}/see_the_monastery.gif`,                            
                            answer: 'วัด',                            
                        },
                        {
                            url: `${path}/see_the_cat.gif`,                            
                            answer: 'เเมว',                            
                        },
                        {
                            url: `${path}/see_the_car.gif`,                            
                            answer: 'รถยนต์',                            
                        }
                    ]
                }
            },            
        };        
    },
    created () {
        !this.$store.state.user_id ? window.location.replace("/#/logout/") : '';          
    },
    methods: {
        setShowContent() {
            this.blur = false;           
        },
        setShowModalCorrect() {
            // this.blur = true;
            this.checkCorrect = 'correct';
        },
        setShowModalInCorrect() {
            // this.blur = true;
            this.checkCorrect = 'incorrect';
        },
        checkGameOver() {            
            console.log('Count Game Over'+ (this.countGameOver + 1));
            this.countGameOver += 1;
            if(this.countGameOver >= 3){                
                this.star = 1;
                this.countGameOver = 0;
                this.updateCheckpointStarInFirebase();
                this.setShowModalInCorrect();                
            }else{
                this.resetGame();
            }            
        },
        checkAnswer(level, answer, correctAnswer) {

            const getRoundByLevel = this.levels[level].round;
            this.current_round += 1;
            
            if(answer !== correctAnswer){
                this.current_round = 0;
                this.checkGameOver();
                soundAnswer('incorrect');
            }else{
                if(getRoundByLevel === this.current_round){
                    this.star = this.countGameOver === 2 ? 2 : 3;
                    this.countGameOver = 0; 
                    this.resetGame();      
                    this.setShowModalCorrect();
                    soundAnswer('correct');
                    this.updateCheckpointStarInFirebase()
                }
            }

        },
        resetGame(){
            this.blur = false;
            this.checkCorrect = '';
            this.current_round = 0;
        },
        nextCheckPoint(){            
            const checkpoints = this.$store.state.checkpoints;
            const level = this.$store.state.level;
            var parseCheckpoint = JSON.parse(JSON.stringify(checkpoints));
            const starByCheckpoint = parseCheckpoint[level];
            const my_checkpoint = 4;
            const checkpoint_index = [1, 2, 3, 4, 5, 6];

            const next = checkpoint_index.filter((i) => {
                const star = starByCheckpoint[`checkpoint_${i}`];
                return i > my_checkpoint && star < 3 ? i : '';                
            });

            window.location.replace(`/#/checkpoint/${next.length > 0 ? next[0]: ''}`);
        },
        async updateCheckpointStarInFirebase() {
            const checkpoints = this.$store.state.checkpoints;
            const level = this.$store.state.level;
            const document_id = this.$store.state.user_id;
            const checkpointUpdate = {
                checkpoint_4: this.star
            }

            const user = this.$store.state.user;
            await logPlay(user, 4, this.star);

            var parseCheckpoint = JSON.parse(JSON.stringify(checkpoints));
            const starByCheckpoint = parseCheckpoint[level]['checkpoint_4'];         

            if(this.star > starByCheckpoint){
                parseCheckpoint[level]['checkpoint_4'] = this.star;
                await actionUpdateCheckpoint(document_id, level, checkpoints, checkpointUpdate);
                this.$store.dispatch('setCheckPoint', parseCheckpoint);
            }
        }
    }
};
</script>